import React, { Component } from "react";
import AuthService, { IAuthService } from "../Services/Auth/AuthService";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";

export const AuthContext = React.createContext<IAuthService>(null);

export const AuthConsumer = AuthContext.Consumer;

export class AuthProvider extends Component<any, any> {
    authService;
    constructor(props: any) {
        super(props);
        
        this.state = {
            isReady: false
        }
        this.authService = new AuthService();
    }

    componentDidMount() {
        this.authService.initialize()
            .then(() => {
                this.setState({ isReady: true })
            });
    }

    render() {
        if (!this.state.isReady) {
            return <AbpnSpinner/>
        }
        return <AuthContext.Provider value={this.authService}>{this.props.children}</AuthContext.Provider>;
    }
}